const DEFAULT_COOKIE_DAYS = 7;
const HOURS_PER_DAY = 24;
const MINUTES_PER_HOUR = 60;
const SECONDS_PER_MINUTE = 60;
const MILLISECONDS_PER_SECOND = 1000;
const MILLISECONDS_PER_DAY = HOURS_PER_DAY * MINUTES_PER_HOUR * SECONDS_PER_MINUTE * MILLISECONDS_PER_SECOND;

export const setCookie = (name: string, value: string, days = DEFAULT_COOKIE_DAYS): void => {
  const expires = new Date();
  expires.setTime(expires.getTime() + days * MILLISECONDS_PER_DAY);
  const cookieString = `${name}=${value};expires=${expires.toUTCString()};path=/;SameSite=Strict;Secure`;
  // biome-ignore lint/suspicious/noDocumentCookie: <ookie setting requires direct assignment>
  document.cookie = cookieString;
};

export const getCookie = (name: string): string | null => {
  const nameEQ = `${name}=`;
  const cookies = document.cookie.split(";");

  for (const cookie of cookies) {
    const c = cookie.trim();
    if (c.indexOf(nameEQ) === 0) {
      return c.slice(nameEQ.length);
    }
  }

  return null;
};

export const removeCookie = (name: string): void => {
  const cookieString = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
  // biome-ignore lint/suspicious/noDocumentCookie: <ookie setting requires direct assignment>
  document.cookie = cookieString;
};
